var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 896,
    height: 1,
    viewBox: "0 0 896 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 0.500122,
    x2: 896,
    y2: 0.500044,
    stroke: "#247EE4",
    strokeDasharray: "20 20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSep2);
export default __webpack_public_path__ + "static/media/sep2.7fd4308da038e9ef03ffc5a1e5ae572b.svg";
export { ForwardRef as ReactComponent };